import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getTotalCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import { mapGetters } from 'vuex';
export default {
  name: 'SlotCounterTotalSecond',
  components: {},
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    refIndex: {
      type: Number,
      required: true
    },
    totalCounterName: {
      type: String,
      default: ''
    },
    totalCounterDisplayName: {
      type: String,
      default: '趋势'
    },
    totalCounterKind: {
      type: String,
      default: ''
    },
    slotCounterName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      downloadLoading: false,
      slotOption: '',
      selectedArea: '全部',
      totalStats: null,
      slotStats: null,
      compareTotalStats: null,
      compareSlotStats: null,
      groupData: [],
      xAxisData: [],
      yAxisDatas: {},
      compareMapping: [],
      metricsArr: ['销量近期趋势'],
      borderFix: ['合计/元'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      excelSheets: [{
        tableId: 'tableShop',
        name: '便利店销售额总报',
        tableRows: 2
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadTotalData();
    },
    start: function start() {
      this.loadTotalData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), {}, {
    timeSlots: function timeSlots() {
      var slots = [];

      for (var i = 0; i < 24; i++) {
        slots.push(i.toString());
      }

      return slots;
    }
  }),
  created: function created() {
    for (var i in this.asyncStations) {
      this.compareMapping.push({
        text: this.asyncStations[i]['statTag'],
        value: this.asyncStations[i]['ID'],
        sellerId: this.asyncStations[i]['ID']
      });
    }

    this.loadTotalData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.tableShop.doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs.tableShop.doLayout();
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    progressFormat: function progressFormat(value) {
      return function () {
        return value + '%';
      };
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }
    },
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    showDetail: function showDetail(number, len) {
      return dateUtils.numberFix(number, len);
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadTotalData: function loadTotalData() {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          name: this.slotCounterName,
          start: this.start / 1000,
          end: this.end / 1000
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this2.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this3 = this;

      if (tableArr.length < 1) {
        this.$message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });
        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, dateUtils.timeStampToString(_this3.start / 1000, 'YYYY年MM月DD日') + '~' + dateUtils.timeStampToString(_this3.end / 1000, 'YYYY年MM月DD日') + excelName);
        _this3.downloadLoading = false;
      });
    }
  }
};